import { CircularProgress } from "@material-ui/core";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"; // if using react-router
import axios from "axios";
import firebase from "firebase";
import { verifyAuthTokenWithServer } from "../../../../services/accountApp/authService";

const LoadingPageWithCustomToken: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const customToken = query.get("customToken");
    const redirect = query.get("redirectUrl");
    if (customToken && redirect) {
      // Replace this with your actual API to get a new token
      const exchangeToken = async () => {
        try {
          const userCredential = await firebase
            .auth()
            .signInWithCustomToken(customToken);
          const user = userCredential.user;

          if (!user) throw new Error("No user found after sign-in");
          // Get ID Token (JWT used for auth with Firebase-protected resources)
          const idToken = await user.getIdToken();

          // Refresh token is stored internally by Firebase Auth, but you can access it like this:
          verifyAuthTokenWithServer(idToken, user);

          // const newToken = response.data.token; // adapt to your response shape

          // Redirect with the new token
          const redirectUrl = new URL(redirect);
          redirectUrl.searchParams.set("t", idToken);

          setTimeout(() => {
            window.location.href = redirectUrl.toString();
          }, 1000);
        } catch (error) {
          console.error("Token refresh failed", error);
          // Optionally redirect or show error
        }
      };

      exchangeToken();
    }
  }, [location.search]);

  return (
    <div style={{ marginTop: "20%", textAlign: "center" }}>
      <CircularProgress size={40} />
    </div>
  );
};

export default LoadingPageWithCustomToken;
